import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import MapMarker from './MapMarker';
import ClusterMarker from './ClusterMarker';
import AccommodationInfoBlock from './AccommodationInfoBlock';
import { fitBounds } from 'google-map-react/utils';
import SearchQuery, { stringify } from '../../../front/search-query';
import { connect } from 'react-redux';
import Actions from './actions';
import moment from 'moment';
import Cookies from 'universal-cookie';
import cx from 'classnames';

function createMapOptions(maps) {
    return {
        zoomControlOptions: {
            position: maps.ControlPosition.RIGHT_CENTER,
            style: maps.ZoomControlStyle.SMALL
        },
        mapTypeControlOptions: {
            position: maps.ControlPosition.TOP_RIGHT
        },
        mapTypeControl: true,
        style: { height: '75vh'} 
    }
}

const cookies = new Cookies();

const onChange = (dispatch, filters, isChanging, map ) => {
    if (!isChanging) {
        dispatch(Actions.isChanging(true));
        cookies.set('center', JSON.stringify(map.center), { path: '/' });
        cookies.set('zoom', map.zoom, { path: '/' });
        dispatch(Actions.mapChange(filters, map));
    }
}

const onClickMarker =  (dispatch, villaData, currentMarkerSelected) => {
    dispatch(Actions.hideDetails(villaData));
    if (currentMarkerSelected != villaData.id) {
        dispatch(Actions.setCurrentMarker(villaData.id));
        dispatch(Actions.showDetails(villaData));
    } else {
        dispatch(Actions.setCurrentMarker(null));
    }   
}

const onClickCluster = (dispatch, cluster, zoom) => {
    dispatch(Actions.updateZoom(12, [cluster.latitude,cluster.longitude]));
    cookies.set('zoom', zoom, { path: '/' });
}
const onClose = (dispatch ) => {
    dispatch(Actions.hideDetails());
    dispatch(Actions.setCurrentMarker(null));
}

class GMap extends Component {
    constructor(props) { 
        super(props);
    }
   
    render() {
        const {villas, clusters, filters, dispatch, periodSelected, showBlock , villaData, zoom, center, isChanging, currentMarkerSelected} = this.props;
        return (
            <div className="width-100 height-100vh relative">
                <div className={cx('map-loader-wrapper', (isChanging) ? 'active' : '' )}>
                    <div className="map-loader"></div>
                </div>
                <GoogleMapReact
                    key={this.props.key}
                    bootstrapURLKeys={{key: "AIzaSyAfHNILZgiTfnknlluVkIPPWOatOUHNwAs"}}
                    center={center}
                    zoom={zoom}
                    options={createMapOptions}
                    onChange={onChange.bind(this, dispatch, filters, isChanging )}
                    style={{ height: '100vh' }}
                >
                    {zoom >= 10 && villas.map((villa, idx) => (    
                        <MapMarker
                            key={villa.id}
                            id={villa.id}
                            lat={villa.latitude}
                            lng={villa.longitude}
                            price={villa.price}
                            name={villa.name}
                            picture={villa.picture}
                            maxSleeps={villa.maxSleeps}
                            showMarker={true}
                            villaUri={villa.villaUri}
                            periodSelected={periodSelected}
                            isShowing={currentMarkerSelected == villa.id}
                            onClickMarker={onClickMarker.bind(this, dispatch, villa, currentMarkerSelected)}
                        />
                    ))}
                    {clusters.map((cluster, idx) => (
                        <ClusterMarker
                            key={idx}
                            lat={cluster.latitude}
                            lng={cluster.longitude}
                            quantity={cluster.quantity}
                            onClickCluster={onClickCluster.bind(this, dispatch, cluster, this.props.zoom)}
                        />
                    ))}
                             
                </GoogleMapReact>
                <AccommodationInfoBlock villaData={villaData} periodSelected={periodSelected} showBlock={showBlock} onClose={onClose.bind(this, dispatch)}  maxSleeps={filters.maxSleeps} />   
            </div>
        );
    }
}

export default connect((state) => {
    let periodSelected = null
    if (state.filters.stayStart && state.filters.stayEnd) {
        const start = moment(state.filters.stayStart, 'DD-MM-YYYY');
        const end = moment(state.filters.stayEnd, 'DD-MM-YYYY');
        periodSelected = end.diff(start, 'days');
    }

    return {
        villas: state.villas || [],
        clusters: state.clusters || [],
        filters: state.filters,
        center: state.center,
        periodSelected: periodSelected,
        zoom: state.zoom,
        villaData: state.villaData,
        showBlock: state.showBlock,
        isChanging: state.isChanging,
        currentMarkerSelected: state.currentMarkerSelected
    }
   })(GMap)
